var _style, _defs, _path, _defs2, _mask, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs3, _g, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCycling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 368 298",
    style: {
      enableBackground: "new 0 0 368 298"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000039844796474282921380000011629884043999189657_);}\r\n\t.st1{fill:#E5E5E5;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st2{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st3{mask:url(#mask0_7313_754_00000168809443219284038080000016621189740047757706_);}\r\n\t.st4{fill:#E8E8E8;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st7{stroke:#000000;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st8{fill:#E8E8E8;stroke:#000000;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st9{fill:none;stroke:#E0E0E0;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st10{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter_00000050644942987866838310000002432153168839659700_);}\r\n\t.st11{mask:url(#mask1_7313_754_00000010302112596054559170000002537331982725482371_);}\r\n\t.st12{fill:#FFFFFF;stroke:#000000;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st13{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st14{fill:#FFFFFF;stroke:#E0E0E0;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st15{stroke:#000000;stroke-width:1.2;stroke-miterlimit:10;}\r\n\t.st16{fill:none;stroke:#FFFFFF;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 368,
    height: 298
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092440498549298771320000015477356207342011809_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092440498549298771320000015477356207342011809_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140,2c-1.7,0-3.3,0.7-4.6,1.9L82.9,56.4C28,111.3,28,200.3,82.9,255.2c54.9,54.9,143.9,54.9,198.9,0 l52.5-52.5c1.2-1.2,1.9-2.8,1.9-4.6V5.6c0-2-1.6-3.6-3.6-3.6H140z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 28.7,
    y: 6.2,
    width: 329.1,
    height: 296.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 28.7,
    y: 6.2,
    width: 329.1,
    height: 296.3,
    id: "mask0_7313_754_00000168809443219284038080000016621189740047757706_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140,2c-1.7,0-3.3,0.7-4.6,1.9L63.9,50.5c-54.9,54.9-77,191-22.1,245.9c20.6,20.6,87.1-7.8,113.6-2.6 c44.4,8.6,92.1-4.2,126.4-38.6l52.5-52.5c1.2-1.2,1.9-2.8,1.9-4.6V5.6c0-2-1.6-3.6-3.6-3.6H140z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M182.7,32c-0.1,1.8-0.4,4.5-1.6,7.4c-1.9,4.6-4.9,7.5-6.6,8.8c-3.8-4.6-7.6-9.3-11.4-13.9l-4.4-7.8l-1.2-5.7 c3.6,0.5,8.4,1.6,13.8,4C176.3,27.2,180,29.8,182.7,32L182.7,32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M181.1,39.4c1-2.3,1.4-4.5,1.5-6.2l-3.3-3.3c2.9,4-2,14.2-4.3,17.9C176.7,46.3,179.4,43.6,181.1,39.4 L181.1,39.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M182.7,32c-0.1,1.8-0.4,4.5-1.6,7.4c-1.9,4.6-4.9,7.5-6.6,8.8c-3.8-4.6-7.6-9.3-11.4-13.9l-4.4-7.8l-1.2-5.7 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M149.1,6.8c-3,4-3.6,12.2,4,16.8c5.9,3.6,22.9,3.6,29.6,10.6c2.8-0.4,2.3-9.4-0.1-12.3 c-6-7.1-16.8-7-19.7-11c-0.2,0.6-0.3,1.3-0.3,2.3c0,0.9,0.2,1.7,0.3,2.3C160.8,15,150.8,8.8,149.1,6.8L149.1,6.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M179.3,38.6c2.8,1.2,5.1,2.7,5,3.2c-0.1,0.5-2.3,1.3-6.6,0.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M181.1,39.4c2.8,1.2,3.3,1.8,3.2,2.3c-0.1,0.5-0.4,1.5-4.7,0.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.9,167.9c27.4-6.5,53.8-10.9,79.1-13.6h0c8.7-8.3,19.7-17.7,33.2-27c-6.7-2.5-17-5.4-29.6-4.8 c-21.5,0.9-36.6,11-42.4,15.3c-1.4-0.8-12.8-6.8-24.5-1.4c-6,2.8-9.4,7.3-10.9,9.6c-13.2-3.9-42.1-10.3-76.8-1.7 c-13.9,3.5-25.7,8.6-35.3,13.9c0.2,14.3,2.6,28.6,7.2,42.3C78.1,188.2,111.5,176.8,148.9,167.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M41.5,203.5c30.8-13.3,66.8-25.9,107.5-35.6c79.5-18.8,151.2-19.9,208.2-15"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M145.8,170.1l38.8,12.7l-10.4-13.8l-35-9L145.8,170.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200.9,168.4c-4.5-8.7-11.2-14.8-16.8-15.9l-0.4-0.9l-3.9,1.2c-0.5,0.1-1,0.2-1.4,0.4 c-1.3,0.6-2.4,1.6-3.1,3c-2.7,4.8-1.8,13.6,2.8,22.4c5.6,10.8,14.6,17.6,20.6,15.8h0l0.1,0c0,0,0,0,0.1,0l5-1.6l-0.6-1.3 C206.4,186.9,205.6,177.6,200.9,168.4z M186,181.5c-1.5,0.7-1.5-2.3-2.9-5.1c-1.5-2.8-3.9-4.4-2.4-5.1c1.5-0.7,3.9,1.1,5.4,3.9 C187.5,177.9,187.5,180.8,186,181.5z M186.2,165.9c-1.5,0.7-3.9-1.1-5.4-3.9c-1.5-2.8-1.4-5.7,0.1-6.4c1.5-0.7,3.9,1.1,5.4,3.9 C187.8,162.4,187.7,165.2,186.2,165.9z M199.1,191c-1.5,0.7-3.9-1.1-5.4-3.9c-1.5-2.8-1.4-5.7,0.1-6.4c1.5-0.7,3.9,1.1,5.4,3.9 C200.7,187.4,200.6,190.3,199.1,191z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M200.9,168.4c-0.5-0.9-1-1.8-1.5-2.7l-14.3-13c-0.3-0.1-0.7-0.2-1-0.3l-2,3.1c1.4,0.3,3.1,1.8,4.2,4 c1.5,2.8,1.4,5.7-0.1,6.4c-1.3,0.6-3.4-0.7-4.9-3l-0.4,6.9l0.4,1.2c1.5-0.1,3.5,1.6,4.7,4c1.1,2.1,1.3,4.2,0.8,5.4l6.2,6.5 l0.9,0.4c-0.1-0.1-0.1-0.3-0.2-0.4c-1.5-2.8-1.4-5.7,0.1-6.4c1.5-0.7,3.9,1.1,5.4,3.9c1.2,2.3,1.4,4.6,0.6,5.8l1.1,0.5l3.2-1 C206.2,185,205.2,176.7,200.9,168.4L200.9,168.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M204.2,167.4c-5.8-11.3-15.4-18.2-21.4-15.5c-6,2.7-6.2,14.1-0.3,25.3c5.8,11.3,15.4,18.2,21.4,15.5 C209.9,190,210,178.6,204.2,167.4z M189.3,180.4c-1.5,0.7-3.9-1.1-5.4-3.9c-1.5-2.8-1.4-5.7,0.1-6.4c1.5-0.7,3.9,1.1,5.4,3.9 C190.9,176.9,190.8,179.8,189.3,180.4z M189.5,164.9c-1.5,0.7-3.9-1.1-5.4-3.9c-1.5-2.8-1.4-5.7,0.1-6.4c1.5-0.7,3.9,1.1,5.4,3.9 C191.1,161.4,191,164.2,189.5,164.9z M202.5,190c-1.5,0.7-3.9-1.1-5.4-3.9c-1.5-2.8-1.4-5.7,0.1-6.4c1.5-0.7,3.9,1.1,5.4,3.9 C204,186.4,204,189.3,202.5,190z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M195.1,175.5c0.9-0.5,0.9-2.3-0.1-4.1c-0.9-1.8-2.5-2.8-3.4-2.3c-0.9,0.5-0.9,2.3,0.1,4.1 C192.6,175,194.1,176,195.1,175.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145.1,64.6c2.9-1.8,6-3.9,9.2-6.3c5.5-4.1,10.3-8.3,14.3-12.3c-3.9-7.9-7.8-15.7-11.7-23.6 c-0.9-1.4-2.3-3-4.1-4.7c0,0-0.1,1.6-0.1,1.6c-5.2-3.6-16.4-3.6-28.6-0.7c-8,1.9-29.8,11.9-40.5,27.5c-3.6,5.3-2.2,7.2-4,13.3 C101.4,61.1,123.3,62.9,145.1,64.6L145.1,64.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M144.9,40.1c-1.4,2.4,4.1,16.2,7,19.8c1.8-1.3,3.5-2.6,5.3-3.9c-2.7-2.7-9.2-11.2-11.4-15.8 C145.6,39.7,145.1,39.7,144.9,40.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M145.1,64.6c2.9-1.8,6-3.9,9.2-6.3c5.5-4.1,10.3-8.3,14.3-12.3c-3.9-7.9-7.8-15.7-11.7-23.6 c-0.9-1.4-2.3-3-4.1-4.7c0,0-0.1,1.6-0.1,1.6c-5.2-3.6-16.4-3.6-28.6-0.7c-8,1.9-29.8,11.9-40.5,27.5c-3.6,5.3-2.2,7.2-4,13.3 C101.4,61.1,123.3,62.9,145.1,64.6L145.1,64.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M233.9,152.6c-16.2-22.2-34.9-36.1-41.9-31c-7,5.1,0.4,27.2,16.6,49.4s34.9,36.1,41.9,31 C257.5,197,250,174.8,233.9,152.6L233.9,152.6z M245.5,193.9c-5.3,3.9-20.8-8.5-34.7-27.5c-13.8-19-20.8-37.6-15.5-41.4 c5.3-3.9,20.8,8.5,34.7,27.5C243.8,171.5,250.8,190.1,245.5,193.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M179.3,102.4l-2.9-5.2c1.9-2.9,4.7-6.5,8.5-10.1c4.4-4.2,8.8-7,12.2-8.8c-1.1-0.9-2.1-1.9-3.2-2.8 c-3.4,2.2-7,5-10.8,8.4c-5.6,5.1-9.9,10.2-13.1,14.6C173,99.8,176.1,101.1,179.3,102.4L179.3,102.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M308.2,150.5c11.5,10-66.3,112.3-94.7,150.4c9.3-0.8,20.6,0.8,29.9,0c26-33.1,85-143.5,73.9-150.3 C314.8,150.6,310.7,150.6,308.2,150.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M306.7,150.4c-3.8-10.1,5.7-41.5,13.5-54.2c-0.8,0.3-1.7,0.7-2.6,1c-8.3,13.2-19.5,42.3-16.3,53.1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M204.9,75.7l-5,5.6l9.9,8.8l5-5.6L204.9,75.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.6,170.3l20.3-69.2l3.6,1.3l-20.3,69.2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M111.6,170.3l20.3-69.2l3.6,1.3l-20.3,69.2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M172.4,164.4c-25.1-49.7-74.3-75.5-109.8-57.6c-35.5,17.9-44,72.8-18.9,122.6 c25.1,49.7,74.3,75.5,109.8,57.6C189.1,269,197.5,214.2,172.4,164.4z M146.1,263.6c-29.4,14.8-69.5-5.4-89.7-45.3 s-12.6-84.2,16.8-99.1c29.4-14.8,69.5,5.4,89.7,45.3C183,204.5,175.5,248.8,146.1,263.6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M155.6,97.2l-24.8,1.8l-1.1,62.9l3.9,2.6l2.5-57.9l18.4-3.2L155.6,97.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M124.9,157.3l57.7-5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64.6,125l54.8,38.9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.3,114.5l18.4,55.2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78,117.2l32.4,44.6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M103.3,112l16.1,39"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M54.7,131.5l58.4,50.7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M45.3,152.3l67.9,23"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M112.1,168.9l-68,8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M47.9,204.2l67.2-22.7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.5,231.1l55.6-46.8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M113.1,179.9l-33.9,73.6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M100.5,266.6l13.2-83.4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M128,184.3l-6.1,88.8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.1,185.2c0,0,46.9,73.7,47.4,73.7"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M121.9,182.2l22,86.5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M169.8,244.4l-32-60.1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M177,222.1l-46.2-36.9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M201.3,125.5c5.8,2.6,19.7,15.2,28.4,27.2c13.8,19,20.3,36.4,15,40.3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M231.1,166.3c1.4-1-0.1-5.3-3.3-9.7c-3.2-4.4-6.9-7.1-8.2-6.1c-1.4,1,0.1,5.3,3.3,9.7 C226.1,164.6,229.8,167.3,231.1,166.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M212.2,139.5c-5.1-7.2-9.6-14.1-13.6-20.7c-1.1-1.9-3.1-3.1-5.2-3.2l-7.7-0.4l1.4,3.3l5.2,0.1 c1.5,0,2.9,0.9,3.6,2.2c3.4,6.2,7.7,13,13.1,20.1c5.7,7.5,11.4,13.8,16.7,18.9c0.3,0.3,0.8,0.4,1.2,0.1c0.4-0.3,0.5-0.9,0.2-1.3 C222.2,152.8,217.2,146.5,212.2,139.5L212.2,139.5z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000143614945189531207360000004716827564832689082_",
    filterUnits: "userSpaceOnUse",
    x: 29.3,
    y: 74.8,
    width: 171.2,
    height: 217.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 29.3,
    y: 74.8,
    width: 171.2,
    height: 217.9,
    id: "mask1_7313_754_00000010302112596054559170000002537331982725482371_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      filter: "url(#Adobe_OpacityMaskFilter_00000143614945189531207360000004716827564832689082_)"
    },
    d: " M148.9,167.9c27.4-6.5,53.8-10.9,79.1-13.6h0c8.7-8.3,19.7-17.7,33.2-27c-6.7-2.5-17-5.4-29.6-4.8c-21.5,0.9-36.6,11-42.4,15.3 c-1.4-0.8-12.8-6.8-24.5-1.4c-6,2.8-9.4,7.3-10.9,9.6c-13.2-3.9-42.1-10.3-76.8-1.7c-13.9,3.5-25.7,8.6-35.3,13.9 c0.2,14.3,2.6,28.6,7.2,42.3C78.1,188.2,111.5,176.8,148.9,167.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M145.8,170.1l43.3,14.2l-4.5-12.6l-45.5-11.7L145.8,170.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.6,170.3l20.3-69.2l3.6,1.3l-20.3,69.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M111.6,170.3l20.3-69.2l3.6,1.3l-20.3,69.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.4,164.4c-25.1-49.7-74.3-75.5-109.8-57.6c-35.5,17.9-44,72.8-18.9,122.6c25.1,49.7,74.3,75.5,109.8,57.6 C189.1,269,197.5,214.2,172.4,164.4z M146.1,263.6c-29.4,14.8-69.5-5.4-89.7-45.3s-12.6-84.2,16.8-99.1 c29.4-14.8,69.5,5.4,89.7,45.3C183,204.5,175.5,248.8,146.1,263.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M130.8,196.9l69.1-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M155.6,97.2l-24.8,1.8l-1.1,62.9l3.9,2.6l2.5-57.9l18.4-3.2L155.6,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M64.6,125l54.8,38.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M91.3,114.5l18.4,55.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M78,117.2l32.4,44.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M103.3,112l16.1,39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M54.7,131.5l58.4,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M45.3,152.3l67.9,23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M112.1,168.9l-66,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M47.9,204.2l67.2-22.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.5,231.1l55.6-46.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M113.1,179.9l-33.9,73.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M100.5,266.6l13.2-83.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M128,184.3l-6.1,88.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.1,185.2c0,0,46.9,73.7,47.4,73.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M121.9,182.2l22,86.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M169.8,244.4l-32-60.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M177,222.1l-46.2-36.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M134.1,152.5l1.5-35.3c1.2,1.7,2.4,3.4,3.7,5.1c8,6.6,15.5,14.7,22.1,24c-8-13.1-16.5-26.2-25.4-39.4l0-0.3 l9-1.6c-2.1-2.3-4.1-4.5-6.1-6.6l-8.3,0.6v0c-4.8-7.1-9.7-14.1-14.6-21.3c-2.2-3.7-11-2.6-11,0.4c0,0.9,1.3,1.6,3.7,1.7 c7.2,10.1,14.5,20.2,21.7,30.2l-0.7,40.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M134.1,152.5l1.5-35.3c1.2,1.7,2.4,3.4,3.7,5.1c8,6.6,15.5,14.7,22.1,24c-8-13.1-16.5-26.2-25.4-39.4l0-0.3 l9-1.6c-2.1-2.3-4.1-4.5-6.1-6.6l-8.3,0.6v0c-4.8-7.1-9.7-14.1-14.6-21.3c-2.2-3.7-11-2.6-11,0.4c0,0.9,1.3,1.6,3.7,1.7 c7.2,10.1,14.5,20.2,21.7,30.2l-0.7,40.6"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M200.8,71c-0.5-0.4-1-0.8-1.5-1.2h-11l5.1,8c2.5,1.6,3.9,4.9,5.8,5.9c3.2,1.7,5.2-2.3,9.9-4.3l3.4,3 c2-2.2-0.7-13.8-8.2-11C203,71.9,201.7,71.7,200.8,71L200.8,71z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M157.8,57.2c11.9,10.6,30.6,19.4,35.6,20.6c2.9,0.3,9.9-6,7.9-8.9c-7-4.8-27.6-19.9-38.8-40.4 c-5.3-8.1-12.1-9.7-16.7-7.2C136,26.6,146.9,47.4,157.8,57.2z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M197.3,66.1c1.1,2-6.6,9.3-9.1,9.9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M156.9,56.3c0.3,0.3,0.6,0.6,0.9,0.8c11.9,10.6,30.6,19.4,35.6,20.6c2.9,0.3,9.9-6,7.9-8.9 c-7-4.8-27.6-19.9-38.8-40.4c-3.3-5.1-9.8-9.6-13.9-11"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M213.7,88.6c1.4-1.6,1.9-3.4,1-4.1c-0.8-0.7-2.6-0.1-4,1.5c-1.4,1.6-1.9,3.4-1,4.1 C210.5,90.8,212.3,90.2,213.7,88.6z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M357.2,152.9c-2-22.1-3.9-44.2-5.9-66.3c-18.3,4.6-42.5,12.6-68.7,27.4c-23.7,13.4-41.7,28.1-54.6,40.4h0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M325.4,150.9c-6.1-14.4-0.7-45.9,4.8-58.2c-6.2,2.1-12.7,4.5-19.6,7.4c-12.5,11.5-21.5,38.5-22.4,50.4 C301,150.3,313.4,150.4,325.4,150.9z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M57.6,217.7c-20.7-40.1-13.6-83.4,15.8-98.2c29.4-14.8,68.6,5.1,89.6,47.9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M134.1,92.4c-27,1.1-41-3.7-49.3-10c-9.2-7-9.7-23.5-0.9-36.9c10.7-14.8,51.6-8.8,57.5,0 C139,61.1,136.6,76.7,134.1,92.4L134.1,92.4z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M189.1,153.2l0.8,8.6c2.1,3.7,4.3,7.7,6.4,12c2.5,5.2,4.6,10.1,6.4,14.8c0.6,1.5,2.3,2.2,3.7,1.5 c2-1,4.2-1.9,6.5-2.8c8.9-3.3,17-4.7,23.6-5.2c1.9-0.8,2.1-6-2.9-8.4c-2.8-1.6-19.2-6.2-27.9-21.5c-2.7-2.1-5.3-4.3-8-6.4 L189.1,153.2z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117.8,75.5c16.6,18.7,58.5,60.3,72.1,86.4c0.5-5.4,15.2-9.2,17.2-7.3c-15.6-30.2-40.4-81.4-65.7-109.1 h-22.2L117.8,75.5z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M117.8,75.5c3.2,4,13,15.7,16.6,19.9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M95.6,76.9L91,78.4c-3.9-1.6-5.3-6.4-3.7-9c2.6-4.2,10.5-5.5,15-6.1c8.4-1.1,16.1,1,18.6,3.1 c3.4,2.5,4.2,9-1,10.9l0,0L95.6,76.9L95.6,76.9z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M115.1,78.5l3.6-0.9c7-1.8,1.6-9.3-10.6-9.3c-12.6,0-17.9,5.9-18.2,8c-0.5,4.6,13.4,4.2,19,3.5 C110.9,79.4,113,79,115.1,78.5z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M152.8,115.3c9.9,9.9,32,36.2,41.8,54.5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M228.5,188.8l12.2-0.1l-16.5,4.8l-12.2,0.1L228.5,188.8z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M207.7,183.2l-8.7,7.5c0.4,2.9,13.2-0.5,21.4-3c7.7-2.4,15.4-4.7,16.2-5.4c-0.8-0.8-1.5-1.6-2.3-2.4 L207.7,183.2L207.7,183.2z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235.4,173.3c-1.9-1.1-14.2-4.2-17.4-9.8c-5,1.5-1.6,6.6-5.8,8.4c-3.2,1.3-13.3-5.8-18.6-3.1 c-1.5,0.5-1.3,3.3-0.5,7.3c1.4,7.7,1.6,12.4,6,14.5c2.4,1.2,10.3-2.1,13.6-3.4c8.8-3.4,18.3-4.5,24.8-5 C240.2,181.4,240.7,175.3,235.4,173.3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M227.2,184.4l-16.5,4.8l1.3,4.4l16.5-4.8L227.2,184.4z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M227.2,184.4l12.2-0.1l1.3,4.4l-12.2,0.1L227.2,184.4z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M194.9,128.3c4,8,8.2,17.2,13.1,25.5c1.4,2.3,2.7,4,5.5,6.5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M183.3,152.2c-1.8-5.3,15.8-11.2,20.4-6.2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M89.1,75c0.6-0.1,0.8-1.4,1.6-2.9c0.9-1.7,7-5.5,6.9-6c-0.4-1.5-7.4,0.8-9.1,3.5 C87.3,71.6,87.7,75.3,89.1,75L89.1,75z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M134.1,152.5l1.5-35.3c1.2,1.7,2.4,3.4,3.7,5.1c8,6.6,15.5,14.7,22.1,24c-8-13.1-16.5-26.2-25.4-39.4l0-0.3 l9-1.6c-2.1-2.3-4.1-4.5-6.1-6.6l-8.3,0.6v0c-4.8-7.1-9.7-14.1-14.6-21.3c-2.2-3.7-11-2.6-11,0.4c0,0.9,1.3,1.6,3.7,1.7 c7.2,10.1,14.5,20.2,21.7,30.2l-0.7,40.6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.9,79.8c7.2,10.1,14.5,20.2,21.7,30.2l-0.7,40.6l2.5,1.1c0.3-13.8,0.5-29.9,0.8-41.2 c0-1.5-0.4-3-1.3-4.2C125.1,97.2,109.5,72.9,108.9,79.8z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M134.1,152.5l1.5-35.3c1.2,1.7,2.4,3.4,3.7,5.1c8,6.6,15.5,14.7,22.1,24c-8-13.1-16.5-26.2-25.4-39.4l0-0.3 l9-1.6c-2.1-2.3-4.1-4.5-6.1-6.6l-8.3,0.6v0c-4.8-7.1-9.7-14.1-14.6-21.3c-2.2-3.7-11-2.6-11,0.4c0,0.9,1.3,1.6,3.7,1.7 c7.2,10.1,14.5,20.2,21.7,30.2l-0.7,40.6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M173.1,164.5c-9.2-17-21.8-31.9-30.4-40.2l0.8-0.8c8.6,8.2,20.9,23,30.2,39.8c0.1,0.2-0.4,0.6-0.3,0.8 L173.1,164.5L173.1,164.5z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141,196.3c9.1-4.6,11.5-18.4,5.2-30.8c-6.3-12.4-18.7-18.7-27.9-14.1c-9.1,4.6-11.5,18.4-5.2,30.8 C119.4,194.6,131.9,200.9,141,196.3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M140.3,198.7c10-5,12.7-19.7,6.1-32.7c-6.6-13-20-19.5-29.9-14.4c-10,5-12.7,19.6-6.1,32.7 C117,197.3,130.4,203.7,140.3,198.7z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M151.1,183.7c-1.4,7.6-5.6,11.2-9.8,13c-9.7,4-21.9-1.4-28.2-14.5c-6.6-13.9-3.5-29.2,6.4-33"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M139.2,187.7c5.9-3,7.3-12,3.1-20.2c-4.1-8.2-12.3-12.5-18.1-9.5c-5.9,3-7.3,12-3.1,20.2 C125.2,186.4,133.3,190.7,139.2,187.7z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M137.6,181.2c3.6-1.8,4.4-7.5,1.7-12.7c-2.6-5.2-7.7-8-11.3-6.2c-3.6,1.8-4.4,7.5-1.7,12.7 C129,180.3,134,183,137.6,181.2z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M252.2,202.3c7-5.1-2.1-28.9-18.3-51.1c-9.8-13.5-20.5-23.8-29-28.8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M228.3,150.9c0.5,0.6,0.9,1.2,1.3,1.8c13.8,19,20.3,36.4,15,40.3"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M245.5,113.4l6.4,5.6l1.6,1.4c0.5,0.4,1.1,0.5,1.7,0.4l2.7-0.7l-1.5-2l-2.3-3.2L245.5,113.4z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M251.9,118.9l3.9-1.2l-2.1-1.8l-5.5-0.3L251.9,118.9z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M266.3,112.9l-0.5,0.5l1.3,2.2c1.4,1.5,3.3,1.6,4.1,0.8c0.6-0.6,0.5-1.7,0.4-2c-1-0.8-1.6-1.2-2.5-2 L266.3,112.9L266.3,112.9z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M244,95.9c-1-0.7-1.5-2.1-1.2-3.2c0.5-1.8,3.1-2.4,4.8-2.1c1.5,0.2,3.5,1.2,3.5,2.4 C251.2,94.8,246.3,97.5,244,95.9L244,95.9z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M236.6,111.6l-1.7-0.8c-0.1-1.5,0.5-7.2,2.3-11.4c1.2-2.8,3.7-4.8,6.7-5.4c3.7-0.7,8-0.4,9.9,0.8 c4.6,3.2,13.4,14.9,15.3,17.7c-1.1,0.3-2.2,0.6-3.3,0.9c-2.7-2.3-12.6-11.9-13.4-11.6c-1.7,0.8-1.4,2.6-1.9,3.3 C245.9,107.3,241.2,109.4,236.6,111.6z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M259,166.1c-5.4,0-12.3-7.6-16.3-18.1c-3-8-3.5-15.5-1.2-19.5c0.9-1.6,2.2-2.6,3.8-3c5.5-1.2,13.1,6.7,17.4,17.9 c3,8,3.5,15.5,1.2,19.5c-0.9,1.6-2.2,2.6-3.8,3C259.8,166.1,259.4,166.1,259,166.1L259,166.1z M246.5,127.8c-0.2,0-0.5,0-0.7,0.1 c-0.9,0.2-1.6,0.8-2.2,1.8c-1.9,3.4-1.3,10.5,1.4,17.6c4.1,10.9,10.9,17.3,14.7,16.5c0.9-0.2,1.6-0.8,2.2-1.8 c1.9-3.4,1.3-10.5-1.4-17.6C256.6,134.1,250.4,127.8,246.5,127.8L246.5,127.8z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M258.9,166.8c-5.5,0-12.6-7.8-16.6-18.5c-3.1-8.2-3.5-15.8-1.3-20c0.9-1.7,2.2-2.7,3.8-3 c5.6-1.2,13.4,6.9,17.7,18.4c3.1,8.2,3.5,15.8,1.2,20c-0.9,1.7-2.2,2.7-3.8,3C259.7,166.7,259.3,166.8,258.9,166.8z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M280.5,158.9c-2.8,0-7.2-4.8-10.8-14.4c-2.6-6.9-3.3-13.1-1.9-15.7c0.5-0.9,1.2-1.3,1.7-1.4c2.7-0.6,7.5,4.1,11.3,14.4 c2.6,6.9,3.3,13.1,1.9,15.7c-0.5,0.9-1.2,1.3-1.7,1.4C280.8,158.9,280.7,158.9,280.5,158.9L280.5,158.9z M270,129.1 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0.1-0.6,0.5c-1,1.8-0.6,7.3,2,14.3c3.3,8.8,7.6,13.7,9.3,13.3c0.1,0,0.3-0.1,0.6-0.5 c1-1.8,0.6-7.3-2-14.3C276,133.9,271.8,129.1,270,129.1L270,129.1z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M256.4,146.9c1.1-0.5,1.3-2.4,0.5-4.1c-0.8-1.7-2.4-2.6-3.5-2.1c-1.1,0.5-1.3,2.4-0.5,4.1S255.3,147.4,256.4,146.9z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M269.7,151.6c1.4-0.6,1.5-3.5,0.3-6.5c-1.3-3-3.4-4.9-4.8-4.3c-1.4,0.6-1.5,3.5-0.3,6.5 C266.1,150.3,268.3,152.2,269.7,151.6z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M247.2,146.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.5-0.4-0.4-0.7l5.7-20.2c0.1-0.3,0.4-0.5,0.7-0.4c0.3,0.1,0.5,0.4,0.4,0.7 l-5.7,20.2C247.6,146,247.4,146.2,247.2,146.2z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M246.1,146.6c-0.3,0-0.5-0.2-0.6-0.4c-0.1-0.3,0.1-0.6,0.4-0.7l8.8-2.2c0.3-0.1,0.6,0.1,0.7,0.4c0.1,0.3-0.1,0.6-0.4,0.7 l-8.8,2.2C246.2,146.6,246.2,146.6,246.1,146.6z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M265.7,147.9C265.6,147.9,265.6,147.9,265.7,147.9l-18.1-1.7c-0.3,0-0.6-0.3-0.5-0.6c0-0.3,0.3-0.6,0.6-0.5l18,1.7 c0.3,0,0.6,0.3,0.5,0.6C266.2,147.7,266,147.9,265.7,147.9L265.7,147.9z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M246.9,113.8l17.8,33"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M265.4,145.2c-0.5,0-0.8-0.4-0.9-0.8l-1.2-20.3c0-0.5,0.3-0.9,0.8-0.9c0.5,0,0.9,0.3,0.9,0.8l1.2,20.3 C266.3,144.8,266,145.2,265.4,145.2C265.5,145.2,265.4,145.2,265.4,145.2L265.4,145.2z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M263.6,146.6c-0.1,0-0.2,0-0.2,0l-7.3-3.2c-0.3-0.1-0.4-0.5-0.3-0.8c0.1-0.3,0.5-0.4,0.8-0.3l7.3,3.2 c0.3,0.1,0.4,0.5,0.3,0.8C264.1,146.4,263.9,146.6,263.6,146.6z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.8,118.8l-0.4-3.1c-0.2-1-1.4-1.7-2.5-1.4l-18.2,4.9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.8,118.8l-0.4-3.1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M256.6,123.7l-0.4-3.1c-0.2-1-1.4-1.7-2.5-1.4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M256.6,123.7l-0.4-3.1"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M273.3,143.4c-0.3,0-0.5-0.2-0.6-0.5c-0.1-0.3,0.1-0.6,0.4-0.7l4.6-1.1c0.3-0.1,0.6,0.1,0.7,0.4c0.1,0.3-0.1,0.6-0.4,0.7 l-4.6,1.1C273.4,143.4,273.4,143.4,273.3,143.4z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M277.4,142.5c-0.2,0-0.4-0.1-0.5-0.2c-2.1-2.9-4-5.9-5.7-8.9c-1-1.8-2-3.7-2.9-5.5c-0.2-0.4-0.8-0.7-1.4-0.6l-0.9,0.2 c-0.3,0.1-0.6-0.1-0.7-0.4c-0.1-0.3,0.1-0.6,0.4-0.7l0.9-0.2c1.1-0.3,2.2,0.3,2.7,1.2c0.9,1.8,1.9,3.7,2.9,5.5 c1.7,3,3.6,6,5.7,8.8c0.2,0.3,0.1,0.6-0.1,0.8C277.6,142.4,277.5,142.4,277.4,142.5L277.4,142.5z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M274.1,143c-0.2,0-0.4-0.1-0.5-0.2c-2.1-2.9-4-5.9-5.7-8.9c-1-1.8-2-3.7-2.9-5.5c-0.2-0.4-0.8-0.7-1.4-0.6l-0.9,0.2 c-0.3,0.1-0.6-0.1-0.7-0.4c-0.1-0.3,0.1-0.6,0.4-0.7l0.9-0.2c1.1-0.3,2.2,0.3,2.7,1.2c0.9,1.8,1.9,3.7,2.9,5.5 c1.7,3,3.6,6,5.7,8.8c0.2,0.3,0.1,0.6-0.1,0.8C274.4,143,274.2,143,274.1,143L274.1,143z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M255.8,151.5v-1.9h4.2c2.1,2.4,5.7,6.7,5,7.6c-0.7,0.8-5.1-1.7-7.9-3.5C256.3,153.2,255.8,152.4,255.8,151.5 L255.8,151.5z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M262.3,133.8l-0.5-1.6l3.6-1.2c2.4,1.4,6.7,4,6.3,5c-0.4,0.9-4.9,0-7.8-0.8 C263.1,135.1,262.5,134.5,262.3,133.8z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M234.9,110.8c-0.4,3.1,7.9,13.9,10.6,18.8c0.7,2.1,1.4,4.2,2.2,6.4c0,0,0.4,1,0.8,2c0.7,1.8,2.9,6.5,6,12.6 c0.5-0.3,1.4-0.7,2.4-0.7c0.9,0,1.2,0.4,3.6-0.7l-12.8-34.4c1.5,0.8,3.4,1.6,5.5,2.3c1.7,0.5,3.2,0.9,4.6,1.1 c0.3,2,0.8,4.1,1.3,6.3c0.9,3.6,1.9,6.9,3,9.8c1.8-0.5,3.6-0.9,5.3-1.4l-3.8-18.1c-0.3-1.3-1.1-2.5-2.3-3.3 c-3.3-2.1-9.2-5.4-10.9-6.3C247.2,104.6,234.2,108.3,234.9,110.8L234.9,110.8z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M267.5,128.7c-0.4,0-0.7-0.3-0.8-0.7l-2.9-11.1c-0.1-0.5,0.2-0.9,0.6-1.1c0.5-0.1,0.9,0.2,1.1,0.6l2.9,11.1 c0.1,0.5-0.2,0.9-0.6,1.1C267.6,128.7,267.5,128.7,267.5,128.7z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M318.1,51.8c-0.3-1-1-1.7-2-2.1l-4.5-2l-2.7,3.5L273.1,62c-1.7,0.5-2.6,2.2-2.1,3.9l7.5,25.1l-2.9,3.8 l4.6,2.1l47.2-14.1L318.1,51.8L318.1,51.8z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M314.7,53.9l4.6,2.1l-1.2-4.2c-0.3-1-1-1.7-2-2.1l-4.5-2l-2.7,3.5L273.1,62c-0.9,0.3-1.6,1-2,1.8 c-0.2,0.4-0.2,0.8-0.2,1.2c0,0.3,0,0.6,0.1,0.9L314.7,53.9L314.7,53.9z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M275.6,66.5c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4 C274.2,65.9,274.8,66.5,275.6,66.5z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M279.8,65.3c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4 C278.4,64.7,279,65.3,279.8,65.3z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M267.3,60.3l43.5-13c1-0.3,2.1,0.3,2.4,1.3l9.6,32.1l-47.2,14.1L266,62.7C265.7,61.7,266.3,60.6,267.3,60.3 L267.3,60.3z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M267.3,60.3l43.5-13c1-0.3,2.1,0.3,2.4,1.3l1.6,5.3L267.6,68l-1.6-5.3C265.7,61.7,266.3,60.6,267.3,60.3 L267.3,60.3z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M271,64.5c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4 C269.6,63.9,270.2,64.5,271,64.5z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M275.2,63.2c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4s-1.4,0.6-1.4,1.4 C273.8,62.6,274.4,63.2,275.2,63.2z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M294.8,66.4l-21.6,6.5l4.3,14.4l21.6-6.5L294.8,66.4z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M294.8,66.3l-17.3,20.8"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M273.2,72.8l25.9,7.9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M300.2,67.8l13.3-4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M301.5,72.2l13.3-4"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M302.8,76.6l7.5-2.3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M328.2,83.1l-5.4-2.4"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M309.3,46.5c1.7-0.5,3.4,0.4,3.9,2.1l9.5,32l-48.5,14.5"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M323.7,44l3.7-4"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M283.4,39.9l1.3,6.5"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M276.5,48.3l-6.9-12.8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M245.5,65.1l10.6-0.5"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M130.9,199.2c2.2,0.1,5.5,0,9.3-1.2c2-0.7,3.6-1.5,4.9-2.3c16.1-1.4,32.2-2.7,48.3-4.1l1.3,2.2L130.9,199.2 L130.9,199.2z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M124.8,156.1c1.6-0.1,3.4-0.1,5.6,0.2c2,0.3,3.7,0.7,5.1,1.2c14.7-1.3,30.2-2.5,44.9-3.8 c0.3-0.4,1.6-1.6,2.6-2c1-0.4-0.8-0.4-0.2-0.6L124.8,156.1L124.8,156.1z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M181.9,150.2l1.9,2.6"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M223.9,203.5l-12.7,11.8"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M194,248.6c0.5-2.6,40.1-38.5,41-36.7c1,2.3-7.6,16.4-9.6,20c11.1-11.6,22.2-23.3,33.3-34.9 c-10.9,13.6-38.7,47.5-42,45.6c-3.2-1.8,8-18.2,6.6-18.2C221.6,224.1,194.5,251.1,194,248.6L194,248.6z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.7,298.7c28.5-31.6,43.4-46.9,44.6-45.9c1.1,0.9-12.4,18.9-36.3,49.6"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M235.4,115.8c1.4,2.2,2.9,4.6,4.7,7.1c1.8,2.5,3.6,4.7,5.3,6.8c0.8,2.7,1.7,5.5,2.7,8.3 c1.6,4.5,3.3,8.8,5,12.7"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M199,185.2c5.8-5.1,33-8.8,41.1-7"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.2,212.7c1.3-0.3-5.3-18.7-3.6-46.8c1.4-23.4,7.8-38.4,6.6-38.8c-1.3-0.4-10.2,14.8-11.6,37.7 C29,191.1,37.7,213.1,39.2,212.7L39.2,212.7z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.3,123.2c-0.4-0.3,0.5-2.5,3.5-5.6c2.1-2.1,5.4-4.4,5.8-3.8c0.3,0.4-2.3,3.1-4.1,5 C48.4,121,45.6,123.5,45.3,123.2z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.2,282.9c0.2-0.9,9.2,2.3,25.8,3.3c17,1,25.8-0.5,25.8,1c0,1.5-11.4,5.2-25.7,4.2 C108.4,290.2,97.9,283.9,98.2,282.9z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M154.8,283.8c0.5,0.7,3.2-0.2,5.2-1.7c0.2-0.2,2.4-2.1,2-2.8c-0.5-0.8-2.6-0.3-4.4,0.9 C155.9,281.5,154.4,283.2,154.8,283.8z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M319.4,96.3c1.7-2.2,3.8-4.6,6.4-6.9c5.2-4.8,10.5-7.9,14.7-9.8c-1,4.7-1.3,6.3-2.3,10.9L319.4,96.3L319.4,96.3z"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M334.3,202.7c1.2-1.2,1.9-2.8,1.9-4.6V5.6c0-2-1.6-3.6-3.6-3.6H140"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCycling);
export default __webpack_public_path__ + "static/media/empty-cycling.a9d1c22e4be1da84c891b6155651cef2.svg";
export { ForwardRef as ReactComponent };